/**
 * A stored Google Drive link, only when it is an absolute https:// URL; otherwise null.
 * The link becomes an href, and a javascript: or data: URL there would run in the app's
 * origin on click. The server refuses anything else on every write path
 * (server/constants/documents.js isSafeLink) and the migration cleared older values; this
 * is the last check before render, so a value that slipped past is shown as text instead.
 *
 * @param {unknown} value
 * @returns {string|null}
 */
export const safeHttpsLink = (value) => {
  if (typeof value !== 'string') return null;
  const link = value.trim();
  if (!/^https:\/\/\S+$/i.test(link)) return null;
  try {
    return new URL(link).protocol === 'https:' ? link : null;
  } catch {
    return null;
  }
};
